<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="pr-0">
        <role-div @switchRole="handleSwitchRole"></role-div>
      </el-col>
      <el-col :span="20" class="mt-xs vc-org-page">
        <div class="bg-white border-radius padding text-left">
          <h5 class="role-title">{{ roleInfo.curRole.name }}</h5>
          <div class="role-context">{{ roleInfo.curRole.description }}</div>
          <div class="line-x margin-top"></div>
          <div class="role-menu flex justify-start">
            <div class="item margin-right" :class="{ 'active': roleInfo.tabName == 'privilege' }"
              @click="changeRoleTab('privilege')">
              功能授权
            </div>
            <div class="item margin-right" :class="{ 'active': roleInfo.tabName == 'shop' }"
              @click="changeRoleTab('shop')">
              店铺授权
            </div>
            <div class="item margin-right" :class="{ 'active': roleInfo.tabName == 'staff' }"
              @click="changeRoleTab('staff')">
              员工关联
            </div>
          </div>

          <div v-if="roleInfo.tabName == 'privilege'">
            <privilege-tree ref="privilegeTree" :pgId="roleInfo.curRole.pgId"></privilege-tree>
          </div>
          <div v-if="roleInfo.tabName == 'shop'">
            <role-shop ref="roleShop"></role-shop>
          </div>
          <div v-if="roleInfo.tabName == 'staff'">
            <role-staff ref="roleStaff"></role-staff>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import RoleDiv from '@/components/frame/roleDiv/roleDiv'
import PrivilegeTree from '@/components/frame/privilegeTree/privilegeTree'
import RoleShop from '@/components/frame/roleShop/roleShop'
import RoleStaff from '@/components/frame/roleStaff/roleStaff'

export default {
  name: 'Role',
  components: {
    RoleDiv,
    PrivilegeTree,
    RoleShop,
    RoleStaff
  },
  data() {
    return {
      roleInfo: {
        curRole: {},
        tabName: 'privilege'
      }
    }
  },
  methods: {
    handleSwitchRole(role) {
      this.roleInfo.curRole = role
      this.changeRoleTab('privilege')
    },
    changeRoleTab(tabName) {
      this.roleInfo.tabName = tabName
      setTimeout(() => {
        if (tabName === 'privilege') {
          // privilegeTree 组件现在通过 watch pgId 自动加载权限
          // 不需要手动调用方法
        } else if (tabName === 'shop') {
          this.$refs.roleShop.openRoleShop({ pgId: this.roleInfo.curRole.pgId })
        } else if (tabName === 'staff') {
          this.$refs.roleStaff.openRoleStaff({ pgId: this.roleInfo.curRole.pgId })
        }
      }, 100)
    }
  }
}
</script>

<style scoped>
.pr-0 {
  padding-right: 0;
}

.mt-xs {
  margin-top: 10px;
}

.bg-white {
  background: #fff;
}

.border-radius {
  border-radius: 4px;
}

.padding {
  padding: 15px;
}

.role-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.role-context {
  color: #666;
  margin-bottom: 10px;
}

.line-x {
  height: 1px;
  background: #eee;
}

.role-menu {
  margin: 15px 0;
}

.role-menu .item {
  padding: 5px 15px;
  cursor: pointer;
  border-radius: 4px;
}

.role-menu .item.active {
  background: #409EFF;
  color: #fff;
}

.margin-right {
  margin-right: 10px;
}

.margin-top {
  margin-top: 15px;
}

.flex {
  display: flex;
}

.justify-start {
  justify-content: flex-start;
}
</style>